module.exports = __webpack_public_path__ + "files/06b8289bbd84000f39e49a38b9f9615b.png";